import {Ventrata} from 'types'
import {ButtonGroupInput} from './inputs/ButtonGroupInput'
import {Input} from './inputs/Input'
import {Textarea} from './inputs/Textarea'

type Props = {
  question: Ventrata.Question
  bookingUuid: string
  unitItemId: string
}

export const InputElement = ({question, bookingUuid, unitItemId}: Props) => {
  if (['text', 'number', 'date'].includes(question.inputType)) {
    return (
      <Input type={question.inputType} bookingUuid={bookingUuid} unitItemId={unitItemId} questionId={question.id} />
    )
  }

  if (question.inputType === 'textarea') {
    return <Textarea bookingUuid={bookingUuid} unitItemId={unitItemId} questionId={question.id} />
  }

  if (question.inputType === 'radio') {
    return (
      <ButtonGroupInput
        bookingUuid={bookingUuid}
        unitItemId={unitItemId}
        questionId={question.id}
        options={question.selectOptions || []}
      />
    )
  }

  return <div>Unknown input type {question.inputType}</div>
}
